import {
    PanelBody,
    Button,
    ButtonGroup,
    __experimentalView as View,
    __experimentalText as Text,
} from "@wordpress/components";
import { desktop, mobile, tablet } from "@wordpress/icons";
import React from "react";

const VisibilityControls = ({ attributes, setAttributes }) => {
    return (
        <PanelBody title="Widoczność" initialOpen={false}>
            <View
                style={{
                    padding: "16px 0",
                    borderRadius: "4px",
                }}
            >
                <Text
                    variant="subtitle"
                    as="p"
                    style={{
                        marginBottom: "12px",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#1e1e1e",
                    }}
                >
                    Ukryj na:
                </Text>
                <ButtonGroup
                    style={{
                        width: "100%",
                        gap: "8px",
                        display: "grid",
                        gridTemplateColumns: "repeat(3, 1fr)",
                    }}
                >
                    {[
                        { key: "desktop", icon: desktop, label: "Desktop" },
                        { key: "tablet", icon: tablet, label: "Tablet" },
                        { key: "phone", icon: mobile, label: "Mobile" },
                    ].map(({ key, icon, label }) => (
                        <Button
                            key={key}
                            label={label}
                            isPressed={attributes.hideBreakpoint[key]}
                            onClick={() => {
                                setAttributes({
                                    hideBreakpoint: {
                                        ...attributes.hideBreakpoint,
                                        [key]: !attributes.hideBreakpoint[key],
                                    },
                                });
                            }}
                            title={`Toggle visibility on ${key}`}
                            style={{
                                boxShadow: "none",
                                justifyContent: "center",
                                border: "1px solid #e2e4e7",
                                borderRadius: "4px",
                                background: attributes.hideBreakpoint[key]
                                    ? "#007cba"
                                    : "#fff",
                                color: attributes.hideBreakpoint[key]
                                    ? "#fff"
                                    : "#1e1e1e",
                                padding: "8px 12px",
                                height: "auto",
                                minHeight: "48px",
                                transition: "all 0.2s ease",
                            }}
                        >
                            <View
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "6px",
                                }}
                            >
                                <View
                                    style={{
                                        width: "24px",
                                        height: "24px",
                                        opacity: attributes.hideBreakpoint[key]
                                            ? 0.9
                                            : 0.7,
                                    }}
                                >
                                    {icon}
                                </View>
                                <Text
                                    style={{
                                        fontSize: "12px",
                                        margin: 0,
                                        fontWeight: "500",
                                        color: attributes.hideBreakpoint[key]
                                            ? "#fff"
                                            : "#1e1e1e",
                                        opacity: attributes.hideBreakpoint[key]
                                            ? 1
                                            : 0.9,
                                    }}
                                >
                                    {label}
                                </Text>
                            </View>
                        </Button>
                    ))}
                </ButtonGroup>
            </View>
        </PanelBody>
    );
};

export default VisibilityControls;
